import { render, staticRenderFns } from "./BespokeDisclosureT2.vue?vue&type=template&id=c89130ca&"
import script from "./BespokeDisclosureT2.vue?vue&type=script&lang=js&"
export * from "./BespokeDisclosureT2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports